import Module from '../../Module';

class App extends Module {
  get baseURL() {
    return 'api/v1/healthinfo'
  }

  parseServer(server) {
    return {
      status: server.status
    }
  }

  parseConfig(env) {
    return {
      apps: env.apps ? this.parseAppData(env.apps) : null,
      categoryTitle: env ? env.categoryTitle : false,
      checkAvailability: env ? env.checkAvailability : false,
      reloadPagePeriod: env && env.reloadPagePeriod,
      delivery: env.delivery,
      info: env.info ? this.parseInfo(env.info) : null,
      minimumOrderPrice: env.minimumOrderPrice ? env.minimumOrderPrice : null,
      pages: env.pages,
      // rules,
      socialNetworks: env.socialNetworks ? this.parseSocialNetworks(env.socialNetworks) : null,
      store: env.store,
      layout: env.layout,
    }
  }

  parseStore(store) {
    return {
      name: store.name ? store.name : null,
      shortName: store.shortName ? store.shortName : null,
      slogan: store.slogan ? store.slogan : null,
    }
  }

  parseSocialNetworks(socialNetworks) {
    return {
      instagram: socialNetworks.instagram ? this.parseSocialNetwork(socialNetworks.instagram) : null,
      telegram: socialNetworks.telegram ? this.parseSocialNetwork(socialNetworks.telegram) : null
    }
  }

  parseSocialNetwork(socialNetwork) {
    return {
      active: socialNetwork.active ? socialNetwork.active : false,
      url: socialNetwork.url ? socialNetwork.url : null
    }
  }

  parseInfo(info) {
    return {
      aboutUs: info.aboutUs ? info.aboutUs : null,
      address: info.address ? info.address : null,
      customerClubUrl: info.customerClubUrl ? info.customerClubUrl : null,
      email: info.email ? info.email : null,
      phone: info.phone ? info.phone : null,
      privacyPolicy: info.privacyPolicy ? info.privacyPolicy : null,
      registerLink: info.registerLink ? info.registerLink : null,
      shareMessage: info.shareMessage ? this.parseShareMessage(info.shareMessage) : null,
    }
  }

  parseShareMessage(messages) {
    return messages.map(message => {
      return message
    })
  }

  parseConfigPages(pages) {
    return {
      completeProfile: pages.completeProfile ? this.parseCompleteProfile(pages.completeProfile) : null,
      viewProfile: pages.viewProfile ? this.parseViewProfile(pages.viewProfile) : null,
    }
  }

  parseCompleteProfile(completeProfile) {
    return {
      description: completeProfile.description,
    }
  }

  parseViewProfile(viewProfile) {
    return {
      description: viewProfile.description,
    }
  }

  parseAppData(app) {
    return {
      pwa: app.pwa ? this.parsePlatformAppData(app.pwa) : null,
      android: app.android ? this.parsePlatformAppData(app.android) : null,
      ios: app.ios ? this.parsePlatformAppData(app.ios) : null,
    }
  }

  parsePlatformAppData(platform) {
    return {
      packageName: platform.packageName,
      currentVersion: platform.currentVersion ? this.parseCurrentVersion(platform.currentVersion) : null
    }
  }

  parseCurrentVersion(current) {
    return {
      currentRelease: Number(current.currentRelease),
      forceUpdateRequired: current.forceUpdateRequired,
      storeUrl: current.storeUrl,
      changed: current.changed
    }
  }

  parseConfigDelivery(deliveries) {
    return deliveries.map(delivery => {
      return this.parseDelivery(delivery)
    })
  }

  parseDelivery(delivery) {
    return {
      dayOfWeek: delivery.dayOfWeek ? this.parseDaysOfWeek(delivery.dayOfWeek) : null,
      time: delivery.time ? this.parseDeliveryTime(delivery.time) : null,
      distance: delivery.distance ? this.parseDeliveryDistance(delivery.distance) : null,
      orderPrice: delivery.orderPrice ? this.parseDeliveryOrderPrice(delivery.orderPrice) : null,
      types: delivery.types ? this.parseDeliveryTypes(delivery.types) : null,
    }
  }

  parseDaysOfWeek(daysOfWeek) {
    return daysOfWeek.map(dayOfWeek => {
      return this.parseDayOfWeek(dayOfWeek)
    })
  }

  parseDayOfWeek(day) {
    return {
      0: day
    }
  }

  parseDeliveryDistance(distance) {
    return {
      operator: distance.operator ? distance.operator : null,
      value: distance.value ? distance.value : null,
    }
  }

  parseDeliveryOrderPrice(orderPrice) {
    return {
      operator: orderPrice.operator ? orderPrice.operator : null,
      value: orderPrice.value ? orderPrice.value : null,
    }
  }

  parseDeliveryTime(time) {
    return {
      from: time.from ? time.from : null,
      to: time.to ? time.to : null,
    }
  }

  parseDeliveryTypes(types) {
    return types.map(type => {
      return this.parseDeliveryType(type)
    })
  }

  parseDeliveryType(type) {
    return {
      name: type.name ? type.name : null,
      duration: type.duration ? type.duration : null,
      price: type.price ? type.price : null,
    }
  }

  parseClient(client) {
    return {
      createdAt: client.createdAt,
      deletedAt: client.deletedAt,
      deviceKey: client.deviceKey,
      id: client.id,
      notificationToken: client.notificationToken,
      updatedAt: client.updatedAt,
      device: client.device ? this.parseDevice(client.device) : null
    }
  }

  parseDevice(device) {
    return {
      appVersion: device ? device.appVersion : null,
      manufacturer: device ? device.manufacturer : null,
      model: device ? device.model : null,
      platform: device ? device.platform : null,
      serial: device ? device.serial : null,
      version: device ? device.version : null,
    }
  }

  healthinfo(params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}`, {
          params: params
        })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              server: this.parseServer(data.server)
            }))
          )
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  config() {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`api/v1/config`)
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              config: this.parseConfig(data.env)
            }))
          )
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  deviceinfo(data, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .put(`api/v1/clients/device-info`, {
          params: params,
          data: data
        })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              client: this.parseClient(data.client)
            }))
          )
        })
        .catch(e => {
          reject(e)
        })
    })
  }
}

export default new App()